import type { App } from "vue";
import * as components from "./appch.components.module";

export function useAllComponents(app: App) {
    for (const componentKey of Object.keys(components)) {
        const component = components[componentKey as keyof typeof components];
        app.component(componentKey, component);
    }
}